import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useCustomLegendSchema() {
  const { t } = useTranslation();
  return Yup.object().shape({
    min: Yup.number().required(t("label.isRequiredValidation", { field: t("label.min") })),
    max: Yup.number()
      .required(t("label.isRequiredValidation", { field: t("label.max") }))
      .moreThan(
        Yup.ref("min"),
        t("label.moreThanValidation", {
          field: t("label.max"),
          // eslint-disable-next-line no-template-curly-in-string
          value: "${more}",
        })
      ),
  });
}
